import React from "react";

import("../../stylesheets/fonts.css");

const EnglishCss = () => <></>;

export default EnglishCss;
